import { ProductQtyErrorCode } from '../../../generated/graphql';

export class Validation {
  public static validateQuantity(
    minQty: number,
    ssm: number,
    value: string,
    qtyInStock?: number,
    isBackOrdered?: boolean,
    denyBackOrder?: boolean,
    isUsingDtp?: boolean
  ): { isValid: boolean; numericValue: number; errorCode: ProductQtyErrorCode } {
    const numericValue = Number(value);
    let errorCode = ProductQtyErrorCode.None;

    const isValid = !isNaN(numericValue) && numericValue >= minQty && numericValue % ssm === 0;

    // following logic in ms ValoriseTransaction.cs
    if (isNaN(numericValue) || (numericValue % ssm !== 0 && numericValue >= minQty) || numericValue <= 0) {
      errorCode = ProductQtyErrorCode.InvalidQuantity;
    } else if (qtyInStock && numericValue > qtyInStock && (isUsingDtp || (!isBackOrdered && denyBackOrder))) {
      errorCode = ProductQtyErrorCode.QuantityUnavailable;
    } else if (numericValue < minQty) {
      errorCode = ProductQtyErrorCode.QuantityBelowMin;
    }

    return { isValid, numericValue, errorCode };
  }

  public static isPhoneNumberValid(val: string): boolean {
    let match = val.match(/(^\+)?\d+(\d|\s)+\d$/);
    let isValid = match !== null && val === match[0];

    //check phone length
    const digitOnlyValLength = (val.match(/\d/g) || []).length;
    isValid = isValid ? digitOnlyValLength >= 8 && digitOnlyValLength <= 15 : false;

    return isValid;
  }
}
